<template>
  <div class="content">
    <div class="main">
      <div class="main-top">
        <div style="margin-right: 10px" @click="goBack"><img src="../../../assets/image/back.png"></div>
        <el-date-picker
          v-model="date"
          style="margin-right: 1vw"
          size="medium"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <el-button size="medium" type="primary" @click="select">查询</el-button>
      </div>
      <el-table :data="tableData" border stripe height="76vh">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            <span>{{scope.row.index}}</span>
          </template>
        </el-table-column>
        <el-table-column label="名称">
          <template slot-scope="scope">
            <span>{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="设备号">
          <template slot-scope="scope">
            <span>{{scope.row.tsSersorImei}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.online == '在线'" style="color:#10B33B">{{scope.row.online}}</span>
            <span v-else style="color:#EC0F0F">{{scope.row.online}}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="类型">
          <template slot-scope="scope">
            <span>{{scope.row.label}}</span>
          </template>
        </el-table-column>
        <el-table-column label="监测数据">
          <template slot-scope="scope">
            <span v-if="scope.row.label == '位移'">{{scope.row.offset}}/mm</span>
            <span v-else-if="scope.row.label == '倾角'">{{scope.row.offset+','+scope.row.strain}}/°</span>
            <span v-else-if="scope.row.label == '压力'">{{scope.row.offset}}/kg</span>
          </template>
        </el-table-column>
         <el-table-column label="监测日期">
          <template slot-scope="scope">
            <span>{{scope.row.createDate}}</span>
          </template>
        </el-table-column>
      </el-table>
       <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="1"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="20"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import base from '../../../untils/base'
  import myHttp from '../../../untils/port'
  import util from '../../../untils/util'
  export default {
    data() {
      return {
        projectId: '',
        date: [], 
        tableData: [],
        total: 0,
        pageSize: 20,
        pageNum: 1,
        ids: '',
        id: ''
      }
    },
    created() {
      const {ids, id} = this.$route.query
      this.ids = ids
      console.log(id);
      this.id = id
      this.projectId = util.session.get('groupId')
      this.getData()
    },
    methods: {
      goBack(){
        if(this.$route.query.type==1){
          this.$router.push({
          path: '/highFormwork',
          query: {
            id: this.id
          }
        })
        }else if(this.$route.query.type==2){
          this.$router.push({
          path: '/deepProNew',
          query: {
            index: this.$route.query.index
          }
        })
        }
        
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.pageSize = val
        this.getData()
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.pageNum = val
        this.getData()
      },
      select(){
        this.pageSize = 20
        this.pageNum = 1
        this.getData()
      },
      getData(){
        let startDate = ''
        let endDate = ''
        if(this.date.length != 0){
          startDate = this.date[0]
          endDate = this.date[1]
        }else{
          startDate = ''
          endDate = ''
        }
        myHttp.queryTsDtuRecordByPageListNew({
          tsDtuId: this.ids,
          projectId: this.projectId,
          startDate: startDate,
          endDate: endDate,
          pageSize: this.pageSize,
          pageNum: this.pageNum
        }).then(resp => {
          console.log(resp);
          if(resp.data.code === 200){
            const data = resp.data.data.PageInfo.list
            for(let i=0;i<data.length;i++){
              data[i].index = (this.pageNum - 1) * this.pageSize + 1 + i
            }
            this.tableData = data
            this.total = resp.data.data.PageInfo.total
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      }
    },
  }
</script>

<style scoped>
.content{
  padding: 1vh 1vw;
  height: 100%;
}
.main{
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  padding: 1vh 1vw;
}
.main-top{
  text-align: left;
  margin-bottom: 1vh;
  display: flex;
  align-items: center;
}
</style>